import Avatar from '@atlaskit/avatar';
import { colors, fontFamily } from '@atlaskit/theme';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

export type MobileTriggerProps = {
  readonly userName: string;
  readonly avatarSrc?: string;
  readonly onClick?: () => void;
  readonly logOutUrl?: string;
  readonly logOutMessage?: FormattedMessage.MessageDescriptor;
};

export class MobileTrigger extends Component<MobileTriggerProps> {
  public render() {
    const { userName, avatarSrc, onClick, logOutUrl, logOutMessage } =
      this.props;
    if (avatarSrc !== undefined) {
      if (logOutUrl !== undefined && logOutMessage !== undefined) {
        return (
          <AvatarContainer
            onClick={() => {
              if (onClick) {
                onClick();
                window.location.assign(logOutUrl);
              }
            }}
          >
            <Avatar
              src={avatarSrc}
              name={userName}
              size="medium"
              isInteractive
            />
            <div>
              <DevopsUserName>{userName}</DevopsUserName>
              <DevOpsLogOut href={logOutUrl}>
                <FormattedMessage {...logOutMessage} />
              </DevOpsLogOut>
            </div>
          </AvatarContainer>
        );
      }

      return (
        <AvatarContainer
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}
        >
          <Avatar src={avatarSrc} name={userName} size="small" isInteractive />
          <UserNameLabel>{userName}</UserNameLabel>
        </AvatarContainer>
      );
    } else {
      return (
        <AvatarContainer
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}
        >
          <Avatar size="small" isInteractive />
          <UserNameLabel>{userName}</UserNameLabel>
        </AvatarContainer>
      );
    }
  }
}

const AvatarContainer = styled.div`
  display: flex;
  align-items: center;
  font-family: ${fontFamily};
  font-size: 12px;
  line-height: 12px;
  color: ${colors.N500};
  cursor: pointer;
`;

const UserNameLabel = styled.div`
  padding-left: 10px;
`;
const DevopsUserName = styled.div`
  padding-left: 10px;
  color: ${colors.N30};
  font-weight: 700;
`;
const DevOpsLogOut = styled.a`
  padding-left: 10px;
  text-decoration: none;
  font-weight: 500;
  color: ${colors.N30};
  span {
    margin-top: 4px;
    display: inline-block;
    color: ${colors.N30};
    text-decoration: underline;
  }
`;
